import {useEffect, useState} from 'react';

export const SERVER_ERROR_TIMEOUT = 4000;

/**
 * Auto hide server error
 * @param error
 * @param delay
 */
export const useErrorAutoHide = (error: boolean, delay = SERVER_ERROR_TIMEOUT) => {
  const [show, setShow] = useState(error);

  useEffect(() => {
    if (!error) return;

    setShow(true);

    const timeout = setTimeout(() => {
      setShow(false);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [error]);

  return show;
};
